import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';

import NotificationItem from './NotificationItem';

const propTypes = {
  notifications: PropTypes.array.isRequired,
  onReadAt: PropTypes.func.isRequired,
};

const renderNotifications = (notifications, onReadAt) => {
  if (!notifications.length) {
    return <div className="NotificationsList__no-data">No notifications at this time.</div>;
  }

  return (
    <ul className="NotificationsList__list">
      {
        notifications.map(notification =>
          <NotificationItem
            key={notification.id}
            notification={notification}
            onReadAt={onReadAt}
          />
        )
      }
    </ul>
  );
};

const NotificationsList = ({ notifications, onReadAt }) => (
  <div>
    <h3 className="section-title">Notifications</h3>
    <Card className="NotificationsList minimal">
      <CardBody>
        {renderNotifications(notifications, onReadAt)}
      </CardBody>
    </Card>
  </div>
);

NotificationsList.propTypes = propTypes;

export default NotificationsList;



// WEBPACK FOOTER //
// ./src/features/dashboard/NotificationsList.js